<template>
  <form-item-wrapper
    :designer="designer"
    :field="field"
    :rules="rules"
    :design-state="designState"
    :parent-widget="parentWidget"
    :parent-list="parentList"
    :index-of-parent-list="indexOfParentList"
    :sub-form-row-index="subFormRowIndex"
    :sub-form-col-index="subFormColIndex"
    :sub-form-row-id="subFormRowId"
  >
    <span :class="[{ 'no-focus-input': !focusFlag }, field.options.size]">
      <treeselect
        v-model="fieldModel"
        ref="fieldEditor"
        :options="officeOptions"
        :normalizer="normalizer"
        :required="field.options.required"
        :readOnly="field.options.readOnly"
        :disabled="field.options.disabled"
        :placeholder="field.options.placeholder"
        :clearable="field.options.clearable"
        :class="field.options.customClass"
        noChildrenText="没有数据了"
        noOptionsText="没有数据"
        noResultsText="没有搜索结果"
        @select="changeSelect"
        @open="focusFlag = true"
        @close="focusFlag = false"
      />
    </span>
  </form-item-wrapper>
</template>

<script>
import FormItemWrapper from "@/components/form-designer/form-widget/field-widget/form-item-wrapper";
import emitter from "@/utils/emitter";
import i18n from "@/utils/i18n";
import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin";
import treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import request from "@/utils/request";
// import { deepClone } from "@/utils/util";
export default {
  name: "officeTreeWidget",
  components: {
    FormItemWrapper,
    treeselect,
  },
  componentName: "FieldWidget", //必须固定为FieldWidget，用于接收父级组件的broadcast事件
  mixins: [emitter, fieldMixin, i18n],
  inject: ["refList", "globalOptionData", "globalModel"],
  props: {
    field: Object,
    parentWidget: Object,
    parentList: Array,
    indexOfParentList: Number,
    designer: Object,

    designState: {
      type: Boolean,
      default: false,
    },

    subFormRowIndex: {
      /* 子表单组件行索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormColIndex: {
      /* 子表单组件列索引，从0开始计数 */ type: Number,
      default: -1,
    },
    subFormRowId: {
      /* 子表单组件行Id，唯一id且不可变 */ type: String,
      default: "",
    },
  },
  data() {
    return {
      oldFieldValue: null, //field组件change之前的值
      fieldModel: null,
      rules: [],

      // 机构名称树选项
      officeOptions: [],
      selectNode: {},
      focusFlag: false,
    };
  },
  watch: {
    fieldModel(newVal) {
      this.handleChangeEvent(newVal);
    },
  },
  created() {
    this.registerToRefList();
    this.initEventHandler();
    this.initFieldModel();

    this.getOfficeTree();
    this.addRequird();
  },
  beforeDestroy() {
    this.unregisterFromRefList();
  },
  methods: {
    changeSelect(node) {
      this.setValue(node.id);
      this.selectNode = node;
      this.getSelectNode();
      this.dispatch("VFormRender", "orgTreeSelect", [
        node,
        this.field.options.name,
      ]);
    },
    /** 转换机构数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      };
    },

    officeTree(parentId, isAll, grade) {
      if(window.apiConfig.key!='baoan'){
        return this.$http({
          url: this.$http.adornUrl("/ntApi/handleRequest"), // 孕保系统固定请求此地址
          data: this.$http.adornData({
            uri: "/jumper-mih/system/rbac/officeTree", // 实际请求的外部系统api路径
            type: "get", // 请求外部系统api的请求方式
            params: { parentId, isAll, grade }, // 请求外部系统api所带参数
          }),
        });
      }else{
        return this.$http({
          url: '/jumper-mih/system/rbac/officeTree',
          method: 'get',
          hideLoading: true,
          data: {
            parentId, isAll, grade
          }
        })
      }
    },
    /** 查询机构名称下拉树结构 */
    getOfficeTree() {
      let this_ = this;
      let officeOptions = JSON.parse(localStorage.getItem("officeOptions"));
      if(!officeOptions){
        this_.officeTree("", this.field.options.isAll, "").then((response) => {
          this_.officeOptions = response.data.data;
          localStorage.setItem("officeOptions", JSON.stringify(this_.officeOptions));
        })
      }else{
        this_.officeOptions = officeOptions
      }
    },
    getSelectNode() {
      let tmpFunc = new Function(
        "selectNode",
        this.field.options.getSelectNode
      );
      return tmpFunc.call(this, this.selectNode);
    },
    setDisabled(flag) {
      this.field.options.disabled = flag;
    },
    addRequird() {
      if (this.field.options.required) {
        this.setRequired(true);
      }
    },
  },
};
</script>

<style lang="scss" >
.vue-treeselect__control {
  border-color: #c5c5c5;
}

.mini,
.el-form-item--mini {
  .vue-treeselect__control {
    height: 28px;
  }
  .vue-treeselect div,
  .vue-treeselect span {
    line-height: 25px;
  }
  .el-form-item--medium .el-form-item__label {
    line-height: 25px;
  }
}
.small,
.el-form-item--small {
  .vue-treeselect__control {
    height: 32px;
  }
  .vue-treeselect div,
  .vue-treeselect span {
    line-height: 29px;
  }
  .el-form-item--medium .el-form-item__label {
    line-height: 29px;
  }
}
.medium,
.el-form-item--medium {
  .vue-treeselect__control {
    height: 36px;
  }
  .vue-treeselect div,
  .vue-treeselect span {
    line-height: 33px;
  }
  .el-form-item--medium .el-form-item__label {
    line-height: 33px;
  }
}
.large,
.el-form-item--large {
  .vue-treeselect__control {
    height: 40px;
  }
  .vue-treeselect div,
  .vue-treeselect span {
    line-height: 37px;
  }
  .el-form-item--medium .el-form-item__label {
    line-height: 37px;
  }
}

.vue-treeselect__control {
  border-radius: 0;
}
.vue-treeselect--has-value .vue-treeselect__input {
  vertical-align: middle;
}

.is-error .vue-treeselect__control {
  border-color: #f56c6c;
  background: #faf1ee;
}
.vue-treeselect__control {
  padding-right: 0;
}
.vue-treeselect__control-arrow-container {
  width: 25px;
  background: #f5f7fa;
}

::v-deep .el-form-item--medium .el-form-item__content,
.el-form-item--medium .el-form-item__label {
  line-height: 30px;
}
</style>